import React from 'react'
import { ArrowBackIcon } from '@components/Icons'
import Show from '@components/Show'
import { colors } from '@lib/colors'
import { Image, Pressable, StyleSheet, View } from 'react-native'

interface NavbarProps {
  goBack?: () => void
}

export default function ({ goBack }: NavbarProps) {
  return (
    <View style={styles.navbar}>
      <Show when={goBack}>
        <Pressable
          style={styles.goBack}
          onPress={goBack}
        >
          <ArrowBackIcon
            color={colors.white}
            size={25}
          />
        </Pressable>
      </Show>

      <Image
        source={require('../assets/LogoFull.png')}
        style={styles.brand}
      />
      {/* <Pressable
        style={Platform.OS === 'web' ? styles.hamburgerWeb : styles.hamburger}
        onPress={openMenu}
      >
        <MenuIcon
          color={colors.white}
          size={25}
        />
      </Pressable> */}
    </View>
  )
}

const styles = StyleSheet.create({
  navbar: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: colors.primary,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: 50,
  },
  hamburger: {
    position: 'absolute',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    paddingLeft: 20,
    paddingRight: 20,
    height: '100%',
  },
  goBack: {
    position: 'absolute',
    justifyContent: 'center',
    left: 0,
    bottom: 0,
    paddingLeft: 20,
    paddingRight: 20,
    height: '100%',
  },
  brand: {
    height: 30,
    width: 170,
    marginTop: 10,
    marginBottom: 10,
  },
})
